const idify = (id: string) => id.replace(/[.#*, >+~/[\]=|^$:()`´]/g, '-');

export default idify;
